import bostools from 'BOSTools/ducks/bosTools';

export default {
  bostools,
};
